import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const Browse = lazy(() => import('./Browse'))
const Detail = lazy(() => import('./Detail'))

const routes: RouteObject[] = [
    {
        path: '/epis',
        element: <Browse />
    },
    {
        path: '/epis/equipment/:equipmentId',
        element: <Detail />
    }
]

export default routes
